export const VALIDATION = {
  COMMANDS_OR_STACK_REQUIRED: {
    code: 'COMMANDS_OR_STACK_REQUIRED',
    message:
      'Either Stack ID or at least one command (Start or End) must be selected',
  },
  TITLE_REQUIRED: {
    code: 'TITLE_REQUIRED',
    message: 'Title is required',
  },
  START_DATE_REQUIRED: {
    code: 'START_DATE_REQUIRED',
    message: 'Start date is required',
  },
  END_DATE_AFTER_START: {
    code: 'END_DATE_AFTER_START',
    message: 'End date must be after start date',
  },
  DURATION_REQUIRED: {
    code: 'DURATION_REQUIRED',
    message: 'Duration is required',
  },
  BACKGROUND_COLOR_REQUIRED: {
    code: 'BACKGROUND_COLOR_REQUIRED',
    message: 'Background color is required',
  },
} as const;

export type ValidationKey = keyof typeof VALIDATION;
export type ValidationCode = (typeof VALIDATION)[ValidationKey]['code'];
